// extracted by mini-css-extract-plugin
export default {"content":"dJ3Nb0kr7QEeHu3Fpqb2","anchor":"UjWUsnAUMBkiaFVE9CBi","task-list-item":"BQwBM8uy4C46HBkbM6UY"};